import React from "react";
import "./Dashboard.scss";
import { useAppSelector } from "../../app/hooks";
import { motion } from "framer-motion";

const Dashboard: React.FC = () => {
  const loginDetails = useAppSelector((state) => state.login.loginDetails);

  return (
    <div className="dashboard-container p-4">
      <motion.div
        className="hero-banner"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          background: "#174583",
          color: "white",
          padding: "60px 40px",
          borderRadius: "6px",
          textAlign: "center",
          marginBottom: "30px",
        }}
      >
        <h1 style={{ fontSize: "2.5rem", margin: "0" }}>
          Welcome back, {loginDetails?.FullName || "Administrator"}!
        </h1>
        <p style={{ fontSize: "1.2rem", margin: "10px 0 0", opacity: 0.9 }}>
          Administrative Control Panel & System Management
        </p>
      </motion.div>

      <div>
        <h2
          style={{
            fontSize: "1.5rem",
            color: "#174583",
            marginBottom: "20px",
            fontWeight: 600,
          }}
        >
          Dashboard
        </h2>
        <div></div>
      </div>
    </div>
  );
};

export default Dashboard;
